interface Props<T extends string> {
  options: readonly T[];
  value: T;
  onChange: (v: T) => void;
  renderLabel?: (v: T) => string;
  vertical?: boolean;
}

export function SegmentedToggle<T extends string>({
  options,
  value,
  onChange,
  renderLabel,
  vertical,
}: Props<T>) {
  return (
    <div class={`segmented ${vertical ? 'segmented--vertical' : ''}`}>
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          class={`segmented__btn ${opt === value ? 'segmented__btn--active' : ''}`}
          onClick={() => onChange(opt)}
        >
          {renderLabel ? renderLabel(opt) : opt}
        </button>
      ))}
    </div>
  );
}
